function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path-1628169935424307778",
  d: "M6,5.058v-5.058h-6v5.058c0,0.21 0.108,0.408 0.294,0.516l2.508,1.506l-0.594,1.404l-2.046,0.174l1.554,1.344l-0.474,1.998l1.758,-1.062l1.758,1.062l-0.468,-1.998l1.554,-1.344l-2.046,-0.174l-0.594,-1.404l2.508,-1.506c0.18,-0.108 0.288,-0.3 0.288,-0.516zM2.4,5.442l-1.2,-0.72v-3.522h1.2zM4.8,4.722l-1.2,0.72v-4.242h1.2z",
  vectorEffect: "non-scaling-stroke"
}));

function SvgAdminBadge1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 6 11.999999999999998",
    width: 6,
    height: 11.999999999999998,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,5.058v-5.058h-6v5.058c0,0.21 0.108,0.408 0.294,0.516l2.508,1.506l-0.594,1.404l-2.046,0.174l1.554,1.344l-0.474,1.998l1.758,-1.062l1.758,1.062l-0.468,-1.998l1.554,-1.344l-2.046,-0.174l-0.594,-1.404l2.508,-1.506c0.18,-0.108 0.288,-0.3 0.288,-0.516zM2.4,5.442l-1.2,-0.72v-3.522h1.2zM4.8,4.722l-1.2,0.72v-4.242h1.2z",
    style: {
      stroke: "rgb(140, 140, 140)",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "rgb(125, 103, 6)"
    },
    vectorEffect: "non-scaling-stroke"
  })), _ref2));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminBadge1);
export default __webpack_public_path__ + "static/media/admin-badge1.bbd04dc1.svg";
export { ForwardRef as ReactComponent };